module.exports = __webpack_public_path__ + "static/exterior-1-495c8db3e510f210fe60a0c2f63464ba.jpg";